import { render, staticRenderFns } from "./new.vue?vue&type=template&id=39b70bb0&"
import script from "./new.vue?vue&type=script&lang=ts&"
export * from "./new.vue?vue&type=script&lang=ts&"
import style0 from "./new.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports